import { coreAxios } from "utilities/axios";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from 'react-toastify';


const BASE_URL = process.env.REACT_APP_MAIN_URL

export const AddCurrency = createAsyncThunk(
  "other/AddCurrency",
  async (data) => {
    const response = await coreAxios.post(`${BASE_URL}/api/currency-create/`, data)
    return response.data
  }
); 

export const UpdateCurrency = createAsyncThunk(
  "other/UpdateCurrency",
  async (data) => {
    const response = await coreAxios.put(`${BASE_URL}/api/currency-update/${data.id}/`, data)
    return response.data
  }
);

export const GetCurrencyList = createAsyncThunk(
  "user/GetCurrencyList",
  async () => {
    const {data} = await coreAxios.get(`${BASE_URL}/api/currency-list/`)
    return data
  }
);

export const DeleteCurrency = createAsyncThunk(
  "other/DeleteCurrency",
  async (id) => {
    const response = await coreAxios.delete(`${BASE_URL}/api/currency-delete/${id}/`)
    if (response.status === 226){
      toast.warning(response.data.message)
    }
    return response.status
  }
);

